export enum PaymentType {
  None = 0,
  Ach = 1,
  Wire = 2,
  Both = 3
}

// tslint:disable-next-line:no-namespace
export namespace PaymentType {
  export function toString(crePaymentType: PaymentType): string {
    switch (crePaymentType) {
      case PaymentType.None:
        return 'None';
      case PaymentType.Ach:
        return 'ACH';
      case PaymentType.Wire:
        return 'Wire';
        case PaymentType.Both:
          return 'Both';
      default:
        return '';
    }
  }

  export function listAll() {
    return [PaymentType.Ach, PaymentType.Wire, PaymentType.Both];
  }

  export function toEnum(value: number): PaymentType {
    switch (value) {
      case 1:
        return PaymentType.Ach;
      case 2:
        return PaymentType.Wire
      case 3:
        return PaymentType.Both
      default:
        return PaymentType.None;
    }
  }
}
